import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-nft-reveal-result-modal',
  templateUrl: './nft-reveal-result-v2-modal.component.html',
  styleUrls: ['./nft-reveal-result-v2-modal.component.scss']
})
export class NftRevealResultV2ModalComponent implements OnInit {


  @Output() dataService = new EventEmitter();
  @Input() rewardAddress;
  @Input() rewardType;
  @Input() rewardTokenId;
  @Input() amount;
  @Input() reward;

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
    //console.log("%o",this.reward)
  }

}
